<template>
  <div>
    <el-form ref="form" :model="formData" :rules="rules">
      <el-row :gutter="20">
        <el-col :xs="{span: 20}" :sm="{span: 24}" :md="{span: 24}" :lg="{span: 24}">
          <el-form-item :label="$l('form_label_tag_name') || '标签名称'" prop="scmTagName">
            <el-input v-model="formData.scmTagName" maxlength="50" :placeholder="$l('INDEX.tips_no_data') || '暂无数据'" :disabled="isViewDisabled"
                      clearable size="medium"></el-input>
          </el-form-item>
        </el-col>
        <el-col  :xs="{span: 20}" :sm="{span: 24}" :md="{span: 24}" :lg="{span: 24}">
          <el-form-item :label="$l('form_label_tag_type') || '标签类型'" prop="scmTagType">
            <el-radio-group style="width: 100%;" size="medium" :disabled="isViewDisabled" v-model="formData.scmTagType">
              <el-radio label="C">{{$l('form_radio_publicLabel') || '公共标签'}}</el-radio>
              <el-radio label="P">{{$l('form_radio_privateLabel') || '私有标签'}}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col  :xs="{span: 20}" :sm="{span: 24}" :md="{span: 24}" :lg="{span: 24}">
          <el-form-item :label="$l('form_label_status') || '是否有效'" prop="scmTagStatus">
            <el-radio-group style="width: 100%;" size="medium" disabled v-model="formData.scmTagStatus">
              <el-radio label="Y">{{$l('form_radio_valid') || '有效'}}</el-radio>
              <el-radio label="N">{{$l('form_radio_invalid') || '无效'}}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col v-if="createDataDisabled">
          <div style="font-size: 14px; color: #717171;">
            <span>Create：{{formData.createByName?formData.createByName:'--'}} at {{formData.createDate?formData.createDate:'--'}}</span>
          </div>
          <div style="font-size: 14px; color: #717171;">
            <span>Modify：{{formData.modifyByName?formData.modifyByName:'--'}} at {{formData.modifyDate?formData.modifyDate:'--'}}</span>
          </div>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>

export default {
  data () {
    return {
      createDataDisabled: false,
      isViewDisabled: false,
      formData: {
        scmTagName: '', // 标签名称
        scmTagStatus: '', // 是否有效
        scmTagType: '', // 标签类型
        createByName: '', // 创建人
        createDate: '', // 创建时间
        modifyByName: '', // 修改人
        modifyDate: ''// 修改时间
      },
      rules: {
        scmTagName: [
          { required: true, message: '请输入标签名称', trigger: 'blur' }
        ],
        scmTagType: [
          { required: true, message: '请选择标签类型', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    // 初始化表单数据
    init () {
      this.isViewDisabled = false
      this.reset()
      this.formData.scmTagCode = ''
    },
    // 加载表单数据（新增，编辑，详情）
    fromLoad (ref, val = '') {
      this.init()
      if (ref !== 'add') {
        this.createDataDisabled = true
        let param = { scmTagCode: val }
        this.$api.scmTagDetailApi(param).then(res => {
          this.formData = res.body
        })
        // 控制组件不可编辑
        if (ref === 'detail') {
          this.isViewDisabled = true
        }
      } else {
        this.createDataDisabled = false
        this.formData.scmTagStatus = 'Y'
      }
    },
    // 保存数据
    save () {
      // 校验表单正确性
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$api.scmTagSaveApi(this.formData)
            .then(() => {
              this.$message({
                showClose: true,
                message: this.$l('INDEX.tips_save_ok') || '保存成功',
                type: 'success'
              })
              // 通知父组件保存成功
              this.$emit('success')
            })
        } else {
          return false
        }
      })
    },
    reset(){
      this.formData = {
        scmTagName: '', // 标签名称
        scmTagStatus: '', // 是否有效
        scmTagType: '', // 标签类型
        createByName: '', // 创建人
        createDate: '', // 创建时间
        modifyByName: '', // 修改人
        modifyDate: ''// 修改时间
      }
    }
  }
}
</script>
